import React from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";

// Self-hosted so no visitor request goes to Google Fonts.
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";
import "@fontsource/oswald/400.css";
// Import shared UI styles (Tailwind CSS + Lemonade brand variables)
import "@lemonadetraining/web-ui/styles/globals.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthContextProvider, firebaseAuth } from "@lemonadetraining/web-shared";
import { appReduxStore } from "@lemonadetraining/web-shared";
import { signOut } from "firebase/auth";

// Check for logout signal BEFORE rendering anything
const urlParams = new URLSearchParams(window.location.search);
const logoutSignal = urlParams.get("logout");

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}
const root = createRoot(container);

if (logoutSignal === "success") {
  // Force logout immediately before app renders
  signOut(firebaseAuth)
    .then(() => {
      // Remove logout parameter and reload the page
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("logout");
      window.location.replace(newUrl.toString());
    })
    .catch((error) => {
      console.error("Logout error:", error);
      // Clean URL even on error
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("logout");
      window.location.replace(newUrl.toString());
    });
} else {
  // Normal render - no logout signal
  root.render(
    <React.StrictMode>
      <Provider store={appReduxStore}>
        <AuthContextProvider>
          <App />
        </AuthContextProvider>
      </Provider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
